export default __webpack_public_path__ + "static/media/WebChat-icon.ca083388.svg";